var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBase40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8436_12673)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8436_12673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7914 39.6519C30.76 39.6519 39.6519 30.7755 39.6519 19.8259C39.6519 8.87636 30.76 0 19.7914 0C9.38494 0 0.847859 7.98969 0 18.1594H26.2511V21.4925H1.42577e-07C0.847859 31.6622 9.38494 39.6519 19.7914 39.6519Z",
    fill: "#0052FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8436_12673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8436_12673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBase40);
export default __webpack_public_path__ + "static/media/ic_base_40.560277c72df8054ee2fa7b4466c582ce.svg";
export { ForwardRef as ReactComponent };